import React, { useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="fixed top-0 w-full flex items-center justify-between backdrop-blur-0 z-50 bg-black/90">
      <div className="flex items-center rounded-md">
        <img
          src={require("../assets/Haptic_logo.webp")}
          alt="Haptic Realities Logo"
          className="h-16 w-auto ml-3"
        />
      </div>
      <ul className="hidden md:flex justify-end space-x-8 p-4 font-medium text-white">
        <li>
          <a href="#home" className="hover:text-yellow-400">
            Home
          </a>
        </li>
        <li>
          <a href="#aboutus" className="hover:text-yellow-400">
            About Us
          </a>
        </li>
        <li>
          <a href="#courses" className="hover:text-yellow-400">
            Courses
          </a>
        </li>
        <li>
          <a href="#placements" className="hover:text-yellow-400">
            Placements
          </a>
        </li>
        <li>
          <a href="#clientwork" className="hover:text-yellow-400">
            Client Work
          </a>
        </li>
        <li>
          <a href="#comments" className="hover:text-yellow-400">
            Student Reviews
          </a>
        </li>
      </ul>
      <div className="md:hidden text-white">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="focus:outline-none mr-3 text-orange-400"
        >
          {isOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
        </button>
      </div>
      {isOpen && (
        <div className="md:hidden fixed top-20 right-0 w-full bg-black/80 z-40">
          <ul className="flex flex-col items-center space-y-6 py-6 text-lg text-white">
            <li>
              <a
                onClick={() => setIsOpen(false)}
                href="#home"
                className="hover:text-yellow-400"
              >
                Home
              </a>
            </li>
            <li>
              <a
                onClick={() => setIsOpen(false)}
                href="#aboutus"
                className="hover:text-yellow-400"
              >
                About Us
              </a>
            </li>
            <li>
              <a
                onClick={() => setIsOpen(false)}
                href="#courses"
                className="hover:text-yellow-400"
              >
                Courses
              </a>
            </li>
            <li>
              <a
                onClick={() => setIsOpen(false)}
                href="#placements"
                className="hover:text-yellow-400"
              >
                Placements
              </a>
            </li>
            <li>
              <a
                onClick={() => setIsOpen(false)}
                href="#clientwork"
                className="hover:text-yellow-400"
              >
                Client Work
              </a>
            </li>
            <li>
              <a
                onClick={() => setIsOpen(false)}
                href="#comments"
                className="hover:text-yellow-400"
              >
                Student Reviews
              </a>
            </li>
          </ul>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
